import "./TotalQuarterCard.scss";
import { formatFloatNumber } from "../../../utils/format";

const TotalQuarterCard = ({ title, amount }) => {
  return (
    <div className="frame-cards">
      <div>
        <div className="frame-icon-title">
          <p>{`${title}`}</p>
        </div>
        <p className="frame-amount">${formatFloatNumber(amount)}</p>
      </div>
    </div>
  );
};

export default TotalQuarterCard;
